<template>
  <div>
    <van-nav-bar :title="title" fixed :left-arrow="leftArrow" @click-left="onClickLeft"/>
  </div>
</template>

<script>
export default {
  name: 'HeaderBar',
  data() {
    return {}
  },
  props: {
    title: {
      type: String,
      default: "标题"
    },
    "leftArrow": {
      type: Boolean,
      default: false
    },
    url: {
      type: String,

    }
  },
  methods: {
    //返回上一页
    onClickLeft: function () {
      if (this.url) {
        this.$router.push(this.url)
      } else {
        this.$router.go(-1)
      }

    },
  },
  mounted: function () {

  }
}
</script>

<style scoped>
</style>
